import React from 'react'

import {
    paletaTonsVerde,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import EstudoFormGarantiasReceitaMensalDetalhada from '../estudo-form/EstudoFormGarantiasReceitaMensalDetalhada'

import GraficoBarrasChart from './GraficoBarrasChart'



const ReceitaAnualChart = ( { variaveisGlobais, values, setFieldValue, estudo, vars, report, popup, moreLessList } ) => {

    return (
        <GraficoBarrasChart
            values={values}
            setFieldValue={setFieldValue}
            estudo={estudo}
            vars={vars}
            report={report}
            popup={popup}
            grafico={estudo.current.graficoReceitaAnual}
            media={estudo.current.graficoReceitaAnualMedia}
            paletaTons={paletaTonsVerde}
            title={LABEL.receitaAnualLongoTempo}
            participacao={true}
            tabela={
                <EstudoFormGarantiasReceitaMensalDetalhada
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    estudo={estudo}
                    vars={vars}
                    popup={true}
                    popupGrafico={false}
                />
            }
            tabelaTitle={LABEL.receitaMensal}
            zoom={true}
            titleZoomTabela={LABEL.tipoReceita}
            moreLessList={moreLessList}
            idListaMoreLess={HARDCODE.receitaAnualChart}
            aiFTOrigem={HARDCODE.analisesInformacoesReceitaAnualChart}
            variaveisGlobais={variaveisGlobais}
        />
    )
}

export default ReceitaAnualChart